
import Aside from '@/components/Aside.vue'
import MarkdownShow from '@/components/MarkdownShow.vue'
import { useGetRequest, useLog } from '@/hooks'
import { AssertGoodResponse, getRandomFromArr } from '@/util/GlobalUtil'
import { ElMessage } from 'element-plus'
import { defineComponent, reactive, ref, toRefs } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: {
    Aside,
    MarkdownShow,
  },
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const commentDisabled = ref<boolean>(true)
    const markdownText = ref<string>(
      '## Linux学习笔记 \n ### 常用命令:' +
        `

      命令 | 描述
      ---|---
      sync | 保存文件
      shutdown | 关机
      shutdown -h 10 | 十分钟后关机
      shutdown -h now 或 halt | 立即关机
      shutdown -r now 或 reboot | 立即重启
      su | 切换到超级管理员
      mkdir *** | 创建目录
      rmdir *** | 删除目录
    ` +
        '\n\n\n\n![avatar](https://dss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=233301930,3031623456&fm=11&gp=0.jpg)'
    )
    const state = reactive({
      commentText: '',
      isLiked: false,
    })

    // 加载博客详情
    const isLoading = ref<boolean>(true)
    const { params } = useRoute()
    // eslint-disable-next-line
    const blog = ref<any>({})

    // 浏览量+1
    useGetRequest(`/api/blog/add_view/${params.blogId}`).then((res) => {
      AssertGoodResponse(res)
      ElMessage.success('浏览量+1')
    })

    // 调接口获取博客详情数据
    useGetRequest(`/api/blog/${params.blogId}`)
      .then((res) => {
        AssertGoodResponse(res)
        blog.value = res.data.data
      })
      .finally(() => {
        isLoading.value = false
      })
    // 随机tag类型
    const randomTagType = () =>
      getRandomFromArr(['info', '', 'danger', 'warning', 'success'])
    // 喜欢按钮
    const like = () => {
      if (state.isLiked) {
        ElMessage.warning('你已经点过赞了哦.')
        return
      }
      // 调点赞接口
      useGetRequest(`/api/blog/like/${params.blogId}`)
        .then((res) => {
          AssertGoodResponse(res)
          state.isLiked = true
          blog.value.likeCount++
          ElMessage.success('点赞成功!')
        })
        .catch((err) => {
          ElMessage.error('点赞失败,' + err)
        })
    }
    // 赞赏按钮
    const appreciate = () => {
      ElMessage.success('感谢你的欣赏, 请扫右边二维哦.')
    }

    return {
      ...toRefs(state),
      isLoading,
      commentDisabled,
      markdownText,
      randomTagType,
      blog,
      currentFullPath: window.location.href,
      appreciate,
      like,
    }
  },
})
